import { AplicationsStatuses, EventsStatuses, EventsTypes } from '@/enums';
import { Filters, SimpleEnumType } from '@/types';

export namespace MarketingFund {
  export enum Pages {
    MARKETING_FUND = 'marketing_fund',
    NEW_EVENT = 'new_event',
    EDIT_EVENT = 'edit_event',
    APLICATION_DETAIL = 'aplication_detail',
    EVENT_DETAIL = 'event_detail',
  }

  export interface Status {
    id: number | string
    name: string
    slug: string
  }

  export interface RequestMarketingFund {
    id: number,
    request_name: string,
    request_status: Status
  }

  export interface SizeAudience {
    id: number
    name: string
    slug: string
  }

  export interface Type {
    id: number
    name: string
    slug: string
  }

  export interface History {
    date: string,
    user: string,
    status: Status,
    comment?: string | null,
  }

  export interface CurrentEventType {
    id: number,
    name: string,
    slug: string,
  }

  export interface EventPayload {
    request: MarketingFund.Event | string,
    mf_event_participants_list?: File | null,
    mf_event_pre_program?: File | null,
    mf_event_pre_expenses?: File | null,
    mf_event_layout_design?: File | null,
  }

  export interface EditEventPayload {
    request: MarketingFund.Event | string,
    mf_event_participants_list?: File | null,
    mf_event_pre_program?: File | null,
    mf_event_pre_expenses?: File | null,
    mf_event_layout_design?: File | null,

    mf_event_participants_list_deleted?: boolean | null,
    mf_event_pre_program_deleted?: boolean | null,
    mf_event_pre_expenses_deleted?: boolean | null,
    mf_event_layout_design_deleted?: boolean | null,
  }

  export interface Aplication {
    [key: string]: unknown,
    id: number
    date: string
    external_id?: number | null,
    name: string
    status: Status | string,
    all_events_count: number
    approval_events_count: number
    revision_events_count: number
    canceled_events_count: number
    completed_events_count: number
    has_unread_change: boolean,
  }

  export interface EventDetail {
    id: number
    event_name: string
    status: Status
    type: Type
    request_marketing_fund: RequestMarketingFund
}

  export interface AplicationDetail {
    [key: string]: unknown,
    id: number,
    date: string,
    name: string,
    status: Status,
    available_send_to_atol: boolean,
  }

  export interface AttachedFile {
    id: number,
    name: string,
  }

  export interface SizeAudienceReached {
    name: string,
    slug: string
  }

  export interface FilesFromServer {
    user_list_file: AttachedFile[],
    pre_programm_file: AttachedFile[],
    pre_expenses_file: AttachedFile[],
    event_layout_design_file: AttachedFile[],
  }

  export interface ReportFiles {
    mf_event_final_agreement: AttachedFile[],
    mf_event_confirming_documents: AttachedFile[],
    mf_event_final_program: AttachedFile[],
    mf_event_final_expenses: AttachedFile[],
    mf_event_final_design: AttachedFile[],
    mf_event_final_banner_mockup: AttachedFile[],
    mf_event_final_participants_list: AttachedFile[],
  }

  export interface EventReport {
    mf_event_final_agreement: AttachedFile[]
    mf_event_confirming_documents: AttachedFile[]
    mf_event_final_program: AttachedFile[]
    mf_event_final_expenses: AttachedFile[]
    mf_event_final_design: AttachedFile[]
    mf_event_final_banner_mockup: AttachedFile[]
    mf_event_final_participants_list: AttachedFile[]
    final_url: string
    final_list_advertised_products: string
    title_promo: string
    text_promo: string
    tags_list: string
    final_location: string
    final_name_event: string
    final_description_event: string
  }

  export interface Event {
  [key: string]: unknown,
  id: number | string,
  event_name: string,
  event_type: Type,
  status: Status,
  date_start: string | null,
  date_end: string | null,
  total_costs: number | null,
  pre_compensation: number | null
  list_advertised_products: string,
  size_audience_reached?: SizeAudience,
  geography_audience_reached?: string | null,
  url: string,
  promotion_description: string,
  other_trademarks: string,
  expected_effect: string,
  location: string,
  expected_sales_volume: number,
  history: History[],
  target_audience: string,
  mf_event_participants_list: AttachedFile[],
  mf_event_pre_program: AttachedFile[],
  mf_event_pre_expenses: AttachedFile[],
  mf_event_layout_design: AttachedFile[],
  request_marketing_fund: RequestMarketingFund
  has_unread_change: boolean;
}

export interface EventForm {
  [key: string]: unknown,
  id: number | string,
  status: Status,
  event_name: string,
  event_type: string,
  event_type_name?: string,
  date_start: string | null,
  date_end: string | null,
  total_costs: number | null,
  pre_compensation: number | null
  list_advertised_products: string,
  size_audience_reached?: string | null,
  size_audience_reached_name?: string,
  geography_audience_reached?: string | null,
  url: string,
  promotion_description: string,
  other_trademarks: string,
  expected_effect: string,
  location: string,
  target_audience: string,
  expected_sales_volume: number | null,
  mf_event_participants_list?: AttachedFile[] | null,
  mf_event_pre_program?: AttachedFile[] | null,
  mf_event_pre_expenses?: AttachedFile[] | null,
  mf_event_layout_design?: AttachedFile[] | null,
  request_marketing_fund: RequestMarketingFund,
  history: History[],
}

export interface ReportForm {
  [key: string]: unknown,
  final_url: string | null,
  final_list_advertised_products: string | null,
  title_promo: string | null,
  text_promo: string | null,
  tags_list: string | null,
  final_location: string | null,
  final_name_event: string | null,
  final_description_event: string | null,
  send_to_atol: boolean,
}

export interface AplicationsFilters {
  [key: string]: unknown,
  status: AplicationsStatuses[] | '';
  date: string[] | '';
  name: string[] | '',
  only_has_unread_changes: boolean;
}

export interface EventsFilters {
  [key: string]: unknown,
  status: EventsStatuses[] | '';
  type: EventsTypes[] | '',
  name: string[] | '',
  only_has_unread_changes: boolean;
}
}
